import { styled, Tooltip } from '@mui/material';
import { dateToLabel } from 'further-ui/utils';
import { ApiResponses } from 'lib/trpcClient';
import { InfoOutlined } from '@mui/icons-material';
import Spacing from 'components/Spacing';

const StyledInfoIcon = styled(InfoOutlined)({
  fontSize: '16px',
  cursor: 'pointer',
});

type LastLoginApiResponse =
  ApiResponses['furtherUser']['list']['results'][number]['lastLogin'];

const LastLoginColumn = ({
  lastLogin,
}: {
  lastLogin: LastLoginApiResponse;
}) => {
  if (!lastLogin?.date) {
    return <div>-</div>;
  }

  let tooltipText = '';
  const portalName = lastLogin.firmName ?? 'Further branded';
  const loginDateString = dateToLabel(lastLogin.date, '', true);

  if (lastLogin.adviserName) {
    tooltipText = `Last logged in as an adviser (${lastLogin.adviserName}) on the ${portalName} portal on ${loginDateString}`;
  } else if (lastLogin.investorName) {
    tooltipText = `Last logged in as an investor (${lastLogin.investorName}) on the ${portalName} portal on ${loginDateString}`;
  } else if (lastLogin.organisationUserName) {
    tooltipText = `Last logged in as an organisation user (${lastLogin.organisationUserName}) on the ${portalName} portal on ${loginDateString}`;
  } else {
    tooltipText = `Last logged in on the ${portalName} portal on ${loginDateString}`;
  }

  return (
    <Spacing direction="row" size="sm">
      {dateToLabel(lastLogin.date)}{' '}
      <Tooltip title={tooltipText} arrow>
        <StyledInfoIcon />
      </Tooltip>
    </Spacing>
  );
};

export default LastLoginColumn;
